import { getUser } from "utils/storage";
import { createContext, useContext, useState, useEffect } from "react";

const PremiumContext = createContext({
  isPremium: false,
  setIsPremium: () => {},
});

export const PremiumProvider = ({ children }) => {
  const [isPremium, setIsPremium] = useState(false);

  useEffect(() => {
    const user = getUser();
    setIsPremium(Boolean(user?.is_premium_member));
  }, []);

  const updateIsPremium = (value) => {
    setIsPremium(Boolean(value));
  };

  return (
    <PremiumContext.Provider
      value={{ isPremium, setIsPremium: updateIsPremium }}
    >
      {children}
    </PremiumContext.Provider>
  );
};

export const usePremium = () => useContext(PremiumContext);
